import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// EN
import enCommon from "./locales/en/common.json";
import enVerificationCertificate from "./locales/en/projects/verificationcertificate.json";
import enMuteAnt from "./locales/en/projects/muteant.json";
import enDonald from "./locales/en/projects/donald.json";

// VI
import viCommon from "./locales/vi/common.json";
import viVerificationCertificate from "./locales/vi/projects/verificationcertificate.json";
import viMuteAnt from "./locales/vi/projects/muteant.json";
import viDonald from "./locales/vi/projects/donald.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    debug: false,

    resources: {
      en: {
        common: enCommon,
        verificationcertificate: enVerificationCertificate,
        muteant: enMuteAnt,
        donald: enDonald,
      },
      vi: {
        common: viCommon,
        verificationcertificate: viVerificationCertificate,
        muteant: viMuteAnt,
        donald: viDonald,
      },
    },

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
